import {
  SaleNote
} from '../../../../../core';

export const saleNotes = {
  paginator: true,
  iconsOfActions: [],
  show: 'No hay registros para mostrar',
  alterColumns: true,
  columns: [
    {
      title: 'Empresa',
      name: 'orderInfo.companyCode',
      type: 'string',
      editable: false,
      checkAll: false,
      mandatory: true,
      visible: true,
      class: 'left',
      value: (element: SaleNote) => element.orderInfo.companyCode
    },
    {
      title: 'Cod. Nota Venta',
      name: 'orderInfo.orderNumber',
      type: 'string',
      editable: false,
      checkAll: false,
      mandatory: true,
      visible: true,
      class: 'left',
      value: (element: SaleNote) => element.orderInfo.orderNumber
    },
    {
      title: 'N° Cotización',
      name: 'orderInfo.quotationNumber',
      type: 'string',
      editable: false,
      checkAll: false,
      mandatory: false,
      visible: true,
      class: 'left',
      value: (element: SaleNote) => (element.orderInfo.quotationNumber || '')
    },
    {
      title: 'Fecha generaci\u00F3n',
      name: 'orderInfo.generatedDate',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'center w120',
      value: (element: SaleNote) => element.orderInfo.generatedDate
    },
    {
      title: 'Cliente',
      name: 'customerInfo.customer',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'left',
      value: (element: SaleNote) => element.customerInfo.customer
    },
    {
      title: 'Tipo Doc.',
      name: 'customerInfo.documentType',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: false,
      class: 'left',
      value: (element: SaleNote) => element.customerInfo.documentType
    },
    {
      title: 'Nro. Doc',
      name: 'customerInfo.identityDocument',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'left',
      value: (element: SaleNote) => element.customerInfo.identityDocument
    },
    {
      title: 'Telf. cliente',
      name: 'customerInfo.contactPhone',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'left',
      value: (element: SaleNote) => element.customerInfo.contactPhone
    },
    {
      title: 'Código Vtex',
      name: 'customerInfo.ecommerceId',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'left',
      value: (element: SaleNote) => element.orderInfo.ecommerceId
    },
    {
      title: 'Correo cliente',
      name: 'customerInfo.contactEmail',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: false,
      class: 'left',
      value: (element: SaleNote) => element.customerInfo.contactEmail
    },
    {
      title: 'Entidad de venta',
      name: 'orderInfo.saleEntity',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'left',
      value: (element: SaleNote) => element.orderInfo.saleEntity
    },
    {
      title: 'Estado',
      name: 'orderInfo.status',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'left',
      value: (element: SaleNote) => element.orderInfo.status
    },
    {
      title: 'Usuario de Autor.',
      name: 'orderInfo.priceAuthUsername',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: false,
      class: 'left',
      value: (element: SaleNote) => element.orderInfo.priceAuthUsername
    },
    {
      title: 'Monto total',
      name: 'orderInfo.totalAmount',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'right',
      value: (element: SaleNote) => element.orderInfo.totalAmount
    },
    {
      title: 'Vendedor',
      name: 'orderInfo.username',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: false,
      class: 'left',
      value: (element: SaleNote) => element.orderInfo.username
    },
    {
      title: '',
      name: 'stateDispatch',
      type: 'editableColumns',
      visible: true,
      editable: true,
      checkAll: true,
      class: 'width-none',
      value: (element: SaleNote) => ''
    }
  ]
};
